import { createContext, useContext } from "react";

/**
 * Per-request holder the SSR server reads after `renderToString` to decide the
 * HTTP status to send. Route components record their status into it during
 * render via {@link useResponseStatus}.
 */
export interface SsrStatus {
  statusCode: number;
}

export const SsrStatusContext = createContext<SsrStatus | null>(null);

/**
 * Record the HTTP status the server should return for the current route.
 *
 * This lets the SSR catch-all send a real `404` for unmatched routes instead of
 * `200`, which is what Google requires to avoid classifying the rendered
 * not-found page as a "Soft 404".
 *
 * No-op on the client (there is no provider during hydration), so components may
 * call it unconditionally in both environments.
 */
export function useResponseStatus(statusCode: number): void {
  const status = useContext(SsrStatusContext);
  if (status) {
    status.statusCode = statusCode;
  }
}
